<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
        <ul>
          <li>
            <span class="ti-email"></span>&nbsp;info@kodiko.gr
          </li>
        </ul>
      </nav>
      <div class="copyright d-flex flex-wrap">
        kodiko.gr&nbsp;{{ (new Date).getFullYear() }} &copy; Big Data Analysis Center (B.D.A.C.)
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style>
</style>
